
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip scroll reset for hash-based navigation (anchors)
    if (location.hash) {
      return;
    }

    // Skip scroll reset if preserveScroll is set in location state
    if (location.state?.preserveScroll) {
      return;
    }

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Scroll to top function
    const scrollToTop = () => {
      if (prefersReducedMotion) {
        // Instant scroll for reduced motion
        window.scrollTo(0, 0);
      } else {
        // Smooth scroll for better UX
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    };

    // Small delay to ensure page content is rendered
    const timeoutId = setTimeout(scrollToTop, 0);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default ScrollToTop;
